import React, { createContext, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';

const Ctx = createContext(null);

// Oldalak regisztrálják magukat (kontextus + akciók); a legutóbb regisztrált oldal az aktív
export function CopilotProvider({ children }) {
  const [stack, setStack] = useState([]);
  const [open, setOpen] = useState(false);
  const [sessions, setSessions] = useState({});

  const register = useCallback((entry) => {
    setStack((s) => [...s.filter((e) => e.id !== entry.id), entry]);
    return () => setStack((s) => s.filter((e) => e !== entry));
  }, []);

  const value = useMemo(() => ({
    page: stack.length ? stack[stack.length - 1] : null,
    register, open, setOpen,
    getSession: (pageId) => sessions[pageId] || null,
    setSession: (pageId, sid) => setSessions((m) => ({ ...m, [pageId]: sid })),
  }), [stack, register, open, sessions]);

  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export const useCopilot = () => useContext(Ctx);

// spec: { id, title, getContext(), suggestions: [], actions: { name: { description, params, run(args) } } }
export function useCopilotPage(spec) {
  const ctx = useContext(Ctx);
  const register = ctx?.register;
  const ref = useRef(spec);
  ref.current = spec;
  useEffect(() => {
    if (!register || !spec?.id) return undefined;
    return register({ id: spec.id, ref });
  }, [register, spec?.id]); // eslint-disable-line react-hooks/exhaustive-deps
}
